module.exports = __webpack_public_path__ + "img/step-11.fadb16f5.jpg";